import React, { useEffect, useState, useContext } from "react";


function TitleAndText(props) {

    return (

        <div className="create-mission-card-title-and-text-section">
            <CardTitle>
                {props.title}
            </CardTitle>
            <div className="create-mission-card-text">
                {props.text}
            </div>
        </div>

    )

}

function CardTitle(props) {

    return (
        <div className="create-mission-card-title">
            {props.children}
        </div>
    )
}

function GrayCardTitle(props) {
    return (
        <div className="gray-create-mission-card-title">
            {props.children}
        </div>
    )
}

function GrayCardSubtitle(props) {
    return (
        <div className="gray-create-mission-card-subtitle">
            {props.children}
        </div>
    )
}

export { TitleAndText, CardTitle, GrayCardTitle, GrayCardSubtitle };